import { useIntl } from 'react-intl'
import { AddBoardMeetingBreadCrum } from '../core/_constants'
import { PageTitle } from '../../../../_metronic/layout/core'
import AddBoardMeetingForm from '../components/add-board-meeting-form'
import { useSearchParams } from 'react-router-dom'

export const AddBoardMeeting = () => {
    const { formatMessage } = useIntl()
    const [searchParams] = useSearchParams()
    const meeting = searchParams.get('meetingId')
    return (
        <>
            <PageTitle
                breadcrumbs={AddBoardMeetingBreadCrum}
                description={formatMessage({ id: 'Schedule New Meeting' })}
            >
                {meeting ? formatMessage({id:'Edit Board Meeting'}) : formatMessage({id:'Schedule New Meeting'})}
            </PageTitle>

            <div className='my-auto w-100'>
                <AddBoardMeetingForm />
            </div>
        </>
    )
}
